document.addEventListener("DOMContentLoaded", function () {

  function hideReviews() {
    const reviewItems = document.querySelectorAll(".jdgm-rev");
    reviewItems.forEach(function (review) {
      const ratingSpan = review.querySelector("span[data-score]");
      if (
        ratingSpan &&
        (ratingSpan.getAttribute("data-score") == "1" ||
         ratingSpan.getAttribute("data-score") == "2" ||
         ratingSpan.getAttribute("data-score") == "3")
      ) {
        review.style.display = "none";
      } else {
        review.style.display = "";
      }
    });
  }

  
  function setupObserver() {
    const reviews = document.querySelector(".jdgm-rev-widg__body");

    if (reviews) {  
      hideReviews();

      const observer = new MutationObserver(hideReviews);

      observer.observe(reviews, { childList: true, subtree: true });
    }
  }

  
  setupObserver();
});
